import {Button} from "antd";
import {useSelector} from "react-redux";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import useAntTable from "../../utils/useAntTable";
import {RootState} from "../../models";
import {PlatformType} from "../../utils/constants";
import * as api from "../../apis/qualification";
import * as minio from "../../utils/minio";

function QualificationReport() {
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform
        ?? PlatformType.Dealer;
    const isDealer = platform === PlatformType.Dealer;
    const {tableProps, search, form} = useAntTable(api.getQualifications, {method: 'post'});

    const columns: StandardColumnsType = [
        ...(!isDealer ? [
            {
                dataIndex: 'dealerNo',
                key: 'dealerNo',
                title: '客户编号'
            },
            {
                dataIndex: 'dealerName',
                key: 'dealerName',
                title: '客户名称'
            }
        ] : []),
        {
            dataIndex: 'code',
            key: 'code',
            title: '商品编号'
        },
        {
            dataIndex: 'batchNo',
            key: 'batchNo',
            title: '批号'
        },
        {
            dataIndex: 'path',
            key: 'path',
            title: '出库批次质检报告',
            render: (path: string) => (
                <Button type={'link'} onClick={() => window.open(minio.getUrl(path), '_blank')}>查看</Button>
            )
        }
    ];

    const searchColumns: StandardColumnsType = [
        ...(!isDealer ? [
            {
                dataIndex: 'dealerNo',
                title: '客户编号',
                search: {colSpan: 6}
            },
            {
                dataIndex: 'dealerName',
                title: '客户名称',
                search: {colSpan: 6}
            }
        ] : []),
        {
            dataIndex: 'code',
            title: '商品编号',
            search: {colSpan: 6}
        },
        {
            dataIndex: 'batchNo',
            title: '批号',
            search: {colSpan: 6}
        }
    ];

    return (
        <PageHeaderLayout>
            <StandardTable {...tableProps}
                           rowKey={(record: any) => `${record.dealerId}-${record.id}`}
                           submit={search.submit}
                           columns={columns}
                           form={form}
                           search={search}
                           extSearchColumns={searchColumns}/>
        </PageHeaderLayout>
    );
}

export default QualificationReport;
